module.exports = __webpack_public_path__ + "static/img/error_bus.6653bdac.svg";